import call from "./call";
import { VoicesUsage, VoicesUsageFilters } from "../Models/voicesUsage";
import { voicesHeaders } from "../Helpers/voicesWorkspace";

export const getVoicesUsage = async (filters: VoicesUsageFilters): Promise<VoicesUsage> => {
  const response = await call.get<VoicesUsage>("/v1/voices/usage/", {
    params: filters,
    headers: voicesHeaders(),
    snack: { error: "voices.usageFetchError" },
  });
  return response.data;
};
